class Storage {
  constructor() {
    this.storageKey = "Asos.Content.Targeting";
    this.storageType = "sessionStorage";
  }

  isAvailable() {
    try {
      const storage = window[this.storageType];
      const x = "__storage_test__";

      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  }

  getData(parameters) {
    if (!this.isAvailable()) {
      return null;
    }

    const key = this.getKey(parameters);
    const storageData = window[this.storageType].getItem(key);

    if (!storageData) {
      return null;
    }

    const data = JSON.parse(storageData);
    return data;
  }

  setData(data, parameters) {
    if (this.isAvailable()) {
      const key = this.getKey(parameters);
      const storageValue = JSON.stringify(data);
      window[this.storageType].setItem(key, storageValue);
    }
  }

  getKey(parameters) {
    const keyName = JSON.stringify(parameters);
    const encryptedKey = btoa(keyName);
    return this.storageKey + "-" + encryptedKey;
  }
}

export default Storage;



// WEBPACK FOOTER //
// ./template/state/modules/contentTargeting/storage.js